import { createElement } from "react";
import {
  Wifi,
  Wallet,
  Utensils,
  Users,
  User,
  Timer,
  Ticket,
  Sunset,
  Sunrise,
  Star,
  Sparkles,
  Smartphone,
  ShieldCheck,
  Share2,
  Send,
  Search,
  Rss,
  QrCode,
  Plane,
  PhoneCall,
  Phone,
  Newspaper,
  Navigation,
  MessagesSquare,
  MessageCircle,
  MapPinned,
  MapPin,
  Map,
  MailOpen,
  Mail,
  Luggage,
  Link2,
  Link,
  LifeBuoy,
  Landmark,
  Key,
  Info,
  Inbox,
  Hotel,
  Home,
  Heart,
  Headphones,
  Globe,
  FileText,
  ExternalLink,
  Earth,
  CreditCard,
  Contact,
  Compass,
  Coffee,
  Clock,
  CircleHelp,
  Car,
  CalendarDays,
  CalendarClock,
  Calendar,
  Building2,
  Building,
  Bell,
  BedDouble,
  AtSign,
} from "lucide-react";

import { getBrandIcon } from "./brand-icons";

// Icons are imported by name (not via `import * as lucideIcons`) so the bundler
// tree-shakes lucide down to what we use. The namespace import pulled all 5,980
// exports into the public bundle — biohazard, origami, tractor and friends were
// really being shipped to every visitor of the marketing site.
//
// The tradeoff: an icon_map value outside this allow-list no longer resolves
// and falls back to Link instead. To add one, put the lucide export name in
// both the import above and the map below (keys are the icon_map values Strapi
// stores). The list is deliberately generous — it covers contact, location,
// communication, time and generic-web glyphs — because Strapi is the source of
// these values and editors can type anything.
const LUCIDE_ICONS = {
  AtSign,
  BedDouble,
  Bell,
  Building,
  Building2,
  Calendar,
  CalendarClock,
  CalendarDays,
  Car,
  CircleHelp,
  Clock,
  Coffee,
  Compass,
  Contact,
  CreditCard,
  Earth,
  ExternalLink,
  FileText,
  Globe,
  Headphones,
  Heart,
  Home,
  Hotel,
  Inbox,
  Info,
  Key,
  Landmark,
  LifeBuoy,
  Link,
  Link2,
  Luggage,
  Mail,
  MailOpen,
  Map,
  MapPin,
  MapPinned,
  MessageCircle,
  MessagesSquare,
  Navigation,
  Newspaper,
  Phone,
  PhoneCall,
  Plane,
  QrCode,
  Rss,
  Search,
  Send,
  Share2,
  ShieldCheck,
  Smartphone,
  Sparkles,
  Star,
  Sunrise,
  Sunset,
  Ticket,
  Timer,
  User,
  Users,
  Utensils,
  Wallet,
  Wifi,
};

// Own-property lookup only: the old module namespace object had a null
// prototype, a plain object literal does not, so a CMS value of "constructor"
// or "toString" would otherwise resolve to a function and be rendered.
const lookupLucideIcon = (iconName) => {
  if (!Object.hasOwn(LUCIDE_ICONS, iconName)) {
    return null;
  }
  return LUCIDE_ICONS[iconName];
};

// Resolve an icon by name: lucide first, then restored brand glyphs, then a
// safe fallback. A missing icon must never throw — a single bad icon_map value
// from the CMS used to crash the whole page render (blank page).
export const getIcon = (iconName) => {
  if (!iconName) {
    return Link;
  }

  const lucideIcon = lookupLucideIcon(iconName);
  if (lucideIcon) {
    return lucideIcon;
  }

  const brandIcon = getBrandIcon(iconName);
  if (brandIcon) {
    return brandIcon;
  }

  console.warn(`Icon "${iconName}" not found; using fallback.`);
  return Link;
};

export const DynamicIcon = (props) => {
  const { name, ...rest } = props;
  return createElement(getIcon(name), rest);
};
